import React, { useState } from 'react';
import axios from 'axios';

const PaymentForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        amount: '',
        purpose: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('http://localhost/virendra/ssbackend/payment/instamojo_checkout', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.longurl) {
                window.location.href = response.data.longurl; // Redirect to Instamojo payment page
            } else {
                setError('Failed to get payment URL');
            }
        } catch (err) {
            console.error(err);
            setError('An error occurred during checkout');
        }

        setLoading(false);
    };

    return (
        <div>
            <h2>Pay with Instamojo</h2>
            <form onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Name" onChange={handleChange} required />
                <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
                <input type="text" name="phone" placeholder="Phone" onChange={handleChange} required />
                <input type="number" name="amount" placeholder="Amount" onChange={handleChange} required />
                <input type="text" name="purpose" placeholder="Purpose" onChange={handleChange} />
                <button type="submit" disabled={loading}>
                    {loading ? 'Processing...' : 'Pay Now'}
                </button>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </form>
        </div>
    );
};

export default PaymentForm;
